import label from "fragments/vendors/label"
import { gql } from "graphql-tag"

const UPDATE_LABEL = gql`
  ${label}

  mutation updateLabel($id: ID!, $labelUpdateInput: LabelUpdateInput!) {
    updateLabel(id: $id, labelUpdateInput: $labelUpdateInput) {
      ...Label
    }
  }
`

export default UPDATE_LABEL
